module.exports = __webpack_public_path__ + "media/images/add-b2efb66343a1bb7220cb4ac034ad53c3.png";